export default "assets/images/icons/linkedin-b078b9af.svg";